const CookieManager = {
    /**
     * Set a cookie
     * 
     * @param {string} name 
     * @param {string|boolean} value 
     * @param {number} exdays (default: 1)
     * 
     * @return {void}
     */
    setCookie(name: string|boolean, value: string|boolean, exdays = 1) : void {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=' + value.toString() + '; ' + expires;
    },

    /**
     * Get a cookie
     * 
     * @param {string} name 
     * 
     * @return {string|boolean|null}
     */
    getCookie(name: string) : string|boolean|null {
        const cookies = document.cookie.split('; ');

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].split('=');

            if (cookie[0] === name) {
                if (cookie[0].toLowerCase() === 'true') {
                    return true;
                } else if (cookie[0].toLowerCase() === 'false') {
                    return false;
                }

                return cookie[0];
            }
        }

        return null;
    },

    /**
     * Remove a cookie
     * 
     * @param {string} name 
     * 
     * @return {void}
     */
    removeCookie(name: string) : void {
        const d = new Date();
        d.setFullYear(1970);
        const expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=null; ' + expires;
    },
};

export default CookieManager;
